import { TableCell } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledTableCell = styled(TableCell)<{
  fontSize?: string;
  truncate?: number;
  wrap?: boolean;
}>(({ theme, fontSize, truncate, wrap }) => ({
  padding: theme.spacing(1.5),
  fontSize: fontSize || "0.875rem",
  ...(truncate && {
    maxWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  }),
  ...(wrap && {
    whiteSpace: "normal",
    wordBreak: "break-word",
  }),
}));

export default StyledTableCell